/**
 * Pişti in words (review 0029): the game tile, the pile in the middle, the seats, the toasts and
 * the count after a deck. Apart, so each language file stays in budget.
 */
export const pistiEn = {
  "variant.pisti": "Pishti",
  "variant.pisti.tag": "Partners · one pile",
  "variant.pisti.blurb":
    "Partners, no tricks: match the top card or play a jack to take the pile. A pishti is 10, first to 101.",
  "pisti.pile.empty": "Empty table",
  "pisti.pile.label": "{count} cards on the table, {card} on top",
  "pisti.stock": "Deck {count} · deal {round}/{rounds}",
  "pisti.banner": "{name}: Pishti! +{points}",
  "pisti.took": "{name} takes {cards}",
  "pisti.why.rank": "Same rank takes the pile",
  "pisti.why.jack": "A jack takes everything",
  "pisti.why.first": "The three face-down cards too; no pishti",
  "pisti.seat.took": "Took the pile · +{cards}",
  "pisti.faceDown": "The face-down cards",
  "pisti.seat": "Cards {cards} · Pishti {pistis}",
  "pisti.count.title": "Deck {hand}",
  "pisti.count.us": "Us",
  "pisti.count.them": "Them",
  "pisti.count.cards": "Cards",
  "pisti.count.aces": "Aces",
  "pisti.count.jacks": "Jacks",
  "pisti.count.clubTwo": "Club 2",
  "pisti.count.diamondTen": "Diamond 10",
  "pisti.count.majority": "Majority",
  "pisti.count.pistis": "Pishti",
  "pisti.count.total": "Total",
  "error.card-not-in-hand": "That card is not in your hand.",
};

type PistiKey = keyof typeof pistiEn;

export const pistiTr: Record<PistiKey, string> = {
  "variant.pisti": "Pişti",
  "variant.pisti.tag": "Ortaklı · yeri topla",
  "variant.pisti.blurb":
    "Ortaklı, el yok: üstteki kartın aynısı ya da vale yeri toplar. Pişti 10 puan, 101'e ilk ulaşan.",
  "pisti.pile.empty": "Yer boş",
  "pisti.pile.label": "Yerde {count} kart, üstte {card}",
  "pisti.stock": "Deste {count} · dağıtım {round}/{rounds}",
  "pisti.banner": "{name}: Pişti! +{points}",
  "pisti.took": "{name} aldı · {cards} kart",
  "pisti.why.rank": "Aynı sayı yeri alır",
  "pisti.why.jack": "Vale hepsini alır",
  "pisti.why.first": "Kapalı üç kart da gelir; pişti sayılmaz",
  "pisti.seat.took": "Yeri aldı · +{cards}",
  "pisti.faceDown": "Kapalı kartlar",
  "pisti.seat": "Kart {cards} · Pişti {pistis}",
  "pisti.count.title": "Deste {hand}",
  "pisti.count.us": "Biz",
  "pisti.count.them": "Onlar",
  "pisti.count.cards": "Kart",
  "pisti.count.aces": "As",
  "pisti.count.jacks": "Vale",
  "pisti.count.clubTwo": "Sinek 2",
  "pisti.count.diamondTen": "Karo 10",
  "pisti.count.majority": "Çoğunluk",
  "pisti.count.pistis": "Pişti",
  "pisti.count.total": "Toplam",
  "error.card-not-in-hand": "Bu kart elinde yok.",
};

/** Draft, like the rest of the Arabic dictionary: waits for a native check (review 0021). */
export const pistiAr: Record<PistiKey, string> = {
  "variant.pisti": "بيشتي",
  "variant.pisti.tag": "شراكة · كومة واحدة",
  "variant.pisti.blurb":
    "شريكان بلا أكلات: ورقة بنفس رقم الورقة العليا أو ولد يأخذ الكومة. البيشتي 10 نقاط، الفائز أول من يصل 101.",
  "pisti.pile.empty": "الطاولة فارغة",
  "pisti.pile.label": "على الطاولة {count} ورقة، وفي الأعلى {card}",
  "pisti.stock": "الرزمة {count} · التوزيع {round}/{rounds}",
  "pisti.banner": "{name}: بيشتي! +{points}",
  "pisti.took": "{name} أخذ {cards}",
  "pisti.why.rank": "الرقم نفسه يأخذ الكومة",
  "pisti.why.jack": "الولد يأخذ كل شيء",
  "pisti.why.first": "والأوراق الثلاث المقلوبة أيضًا؛ لا بيشتي",
  "pisti.seat.took": "أخذ الكومة · +{cards}",
  "pisti.faceDown": "الأوراق المقلوبة",
  "pisti.seat": "أوراق {cards} · بيشتي {pistis}",
  "pisti.count.title": "الرزمة {hand}",
  "pisti.count.us": "نحن",
  "pisti.count.them": "هم",
  "pisti.count.cards": "الأوراق",
  "pisti.count.aces": "الآسات",
  "pisti.count.jacks": "الأولاد",
  "pisti.count.clubTwo": "2 سباتي",
  "pisti.count.diamondTen": "10 ديناري",
  "pisti.count.majority": "أكثر الأوراق",
  "pisti.count.pistis": "بيشتي",
  "pisti.count.total": "المجموع",
  "error.card-not-in-hand": "هذه الورقة ليست في يدك.",
};
